import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  Stack,
  Chip,
} from "@mui/material";

import DnsIcon from "@mui/icons-material/Dns";

import ServerCard from "components/ServerCard";

const WS_URL =
  process.env.REACT_APP_WS_URL ||
  `${window.location.protocol === "https:" ? "wss:" : "ws:"}//${window.location.host}/ws/servers`;

export default function ServersPage() {
  const [servers, setServers] = useState([]);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    let socket = null;
    let reconnectTimer = null;
    let disposed = false;

    const connect = () => {
      if (disposed) return;

      socket = new WebSocket(WS_URL);

      socket.onopen = () => {
        if (!disposed) {
          setConnected(true);
        }
      };

      socket.onmessage = (event) => {
        if (disposed) return;

        try {
          const data = JSON.parse(event.data);

          if (Array.isArray(data.servers)) {
            setServers(data.servers);
          }
        } catch (error) {
          console.error("Servers WebSocket:", error);
        }
      };

      socket.onclose = () => {
        if (disposed) return;

        setConnected(false);

        reconnectTimer = setTimeout(connect, 3000);
      };

      socket.onerror = () => {
        socket.close();
      };
    };

    connect();

    return () => {
      disposed = true;

      clearTimeout(reconnectTimer);

      if (socket) {
        socket.close();
      }
    };
  }, []);

  return (
    <Box sx={{ py: 3 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <DnsIcon color="primary" fontSize="large" />

          <Box>
            <Typography variant="h5" fontWeight={700}>
              Мониторинг серверов
            </Typography>

            <Typography variant="body2" color="text.secondary">
              Состояние оборудования в реальном времени
            </Typography>
          </Box>
        </Stack>

        <Chip
          color={connected ? "success" : "warning"}
          variant="outlined"
          label={connected ? "Подключено" : "Нет соединения"}
          size="small"
        />
      </Stack>

        <Box
        sx={{
            display: "grid",
            gridTemplateColumns: {
            xs: "1fr",                   // Мобильные: 1 карточка
            sm: "repeat(2, minmax(0, 1fr))", // Планшеты: 2 карточки
            lg: "repeat(4, minmax(0, 1fr))", // Большие экраны: 4 карточки
            },
            gap: 2,
            width: "100%",
        }}
        >
        {servers.map((server) => (
            <ServerCard
            key={server.name}
            server={server}
            connected={connected}
            />
        ))}
        </Box>

      {connected && servers.length === 0 && (
        <Typography
          color="text.secondary"
          textAlign="center"
          sx={{ mt: 4 }}
        >
          Нет серверов для отображения
        </Typography>
      )}
    </Box>
  );
}